
type TCallback = (content?: string) => void

export const clipUtils = {
  async set(content: string, success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    if (!content?.length) {
      fail("Parameter cannot be null")
      return
    }
    try {
      await navigator.clipboard.writeText(content)
      success()
    } catch (error) {
      fail(`Fail to set:${error}`)
    }

  },
  async get(success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    try {
      const result = await navigator.clipboard.readText()
      success(result)
    } catch (error) {
      fail(`Fail to get:${error}`)
    }
  },
  async clear(success: TCallback, fail: TCallback): Promise<void> {
    if (!navigator?.clipboard) {
      fail("navigator.clipboard is not found")
      return
    }
    try {
      await navigator.clipboard.writeText('')
      success()
      return
    } catch (error) {
      fail(`Fail to clear:${error}`)
    }
  }
}